import { render, staticRenderFns } from "./tenancy-proportion.vue?vue&type=template&id=f80f58b6&scoped=true&"
import script from "./tenancy-proportion.vue?vue&type=script&lang=js&"
export * from "./tenancy-proportion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80f58b6",
  null
  
)

export default component.exports